import React from 'react';

const ConditionNav = ({ click, tab, img, title, active }) => {
  return (
    <button
      onClick={click}
      className={`flex items-center py-1 focus:outline-none ${tab ? 'text-cf-300' : ''}`}
    >
      <img
        className={`w-5 md:w-6 mr-2  p-1 ${tab ? 'bg-cf-300 rounded' : ''}`}
        src={tab ? active : img}
        alt={img}
      />
      <span className="hidden md:block text-left">{title}</span>
    </button>
  );
};

export default ConditionNav;
